import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css'

window.intlTelInput = intlTelInput
